import script from "./DeportesList.vue?vue&type=script&setup=true&lang=js"
export * from "./DeportesList.vue?vue&type=script&setup=true&lang=js"

import "./DeportesList.vue?vue&type=style&index=0&id=4e982c59&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e982c59"]])

export default __exports__